const FootballStatsCategory = Object.freeze({
    RUSH: "rush",
    TACKLE: "tackle",
    PASS: "pass",
    PASS_TARGET: "pass target",
    OF_SACK: "sacked",
    DF_SACK: "sacks",
    INTERCEPTION: "interception",
    INTERCEPTION_RETURN: "interception return",
    CONTINUED: "continued",
    LATERAL: "lateral",
    FUMBLE_RECOVERED: "fumble recovered",
    FUMBLE_FORCED: "fumble forced",
    FUMBLE_LOST: "fumble lost",
    FUMBLE: "fumble",
    PASS_BROKEN_UP: "pass broken up",
    PUNT: "punt",
    PUNT_RETURN: "punt return",
    PAT_PASS: "pat pass",
    PAT_RUN: "pat run",
    PAT_KICK: "pat kick",
    DOWN: "down",
    TURNOVER_ON_DOWN: "turnover on down",
    TURNOVER_ON_DOWN_REDZONE: "turnover on down redzone",
    PENALTY: "penalty",
    PAT_COMPLETE: "pat complete",
    PUNT_BLOCKED: "punt blocked",
    PUNT_IN20: "in 20",
    KICK_OFF: "kick off",
    KICK_OFF_RETURN: "kick off return",
    RUSHING_TOUCHDOWN: "rushing touchdown",
    SAFETY: "safety",
    FIELD_GOAL: "field goal",
    FIELD_GOAL_REDZONE: "field goal redzone",
    FIELD_GOAL_BLOCKED: "field goal blocked",
    FIELD_GOAL_RETURN: "field goal return",
    DEUCE: "deuce",
    REBOUND_NET: "rebound net",
    REBOUND_NET_RETURN: "rebound net return",
    BAR_BALL: "bar ball",
    BAR_BALL_RETURN: "bar ball return",
    TEAM_LOSS: "team loss",
    SPIKE: "spike",
    KNEEL_DOWN: "kneel down",
    UPDATE_CONTEXT: "update context",
    TOUCHDOWN: "touchdown"
});

export default FootballStatsCategory;
